// extracted by mini-css-extract-plugin
export var button = "_cd-2";
export var iconWrapper = "_cd-0";
export var investigatingIcon = "_cd-1";